import React, { useState } from 'react';
import { Box, Button, Grid, IconButton, MenuItem, Select, Typography, Paper, Radio, RadioGroup, FormControlLabel, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import propTypes from 'prop-types';
import { getJobPositionsInUseList } from 'JobPosition/Domain/Services/GetJobPositionsInUseListService';
import { useEffect } from 'react';
import { createProposalProjectSavingsStaff } from 'ProposalProject/ProposalProjectSavingsStaff/Domain/Services/CreateProposalProjectSavingsStaffService';
import { v4 as uuidv4 } from 'uuid';
import { deleteProposalProjectSavingsStaff } from 'ProposalProject/ProposalProjectSavingsStaff/Domain/Services/DeleteProposalProjectSavingsStaffService';
import { patchProposalProjectSavingsStaff } from 'ProposalProject/ProposalProjectSavingsStaff/Domain/Services/PatchProposalProjectSavingsStaffService';
import { createProposalProjectExternalCost } from 'ProposalProject/ProposalProjectExternalCost/Domain/Services/CreateProposalProjectExternalCostService';
import { deleteProposalProjectExternalCost } from 'ProposalProject/ProposalProjectExternalCost/Domain/Services/DeleteProposalProjectExternalCostService';
import { patchProposalProjectExternalCost } from 'ProposalProject/ProposalProjectExternalCost/Domain/Services/PatchProposalProjectExternalCostService';
import { patchProposalProject } from 'ProposalProject/ProposalProject/Domain/Services/PatchProposalProjectService';
import { ProposalProjectConstants } from 'ProposalProject/ProposalProject/Domain/Model/ProposalProjectConstant';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { ADMIN_PROPOSAL_PROJECT } from 'Shared/Security/Application/Constants/PermissionsConstant';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import SearchableSelect from 'UI/Application/Components/Menus/generic/SearchableSelect';
import { useTranslation } from 'react-i18next';

const SecondStep = ({
    idProposalProject, 
    savingsStaffProposalProject,
    externalCostProposalProject,
    reloadData,
    readOnly = false,
    currentStatus
}) => {
    const { checkPermission } = useAuthContext();

    const headerStyle = {
        backgroundColor: '#0492D4',
        color: 'white',
        p: 1,
        borderRadius: '4px',
        textAlign: 'center',
    };

    const { t } = useTranslation();
    const [benefitsRows, setBenefitsRows] = useState([]); // Usar un estado vacío al inicio
    const [savingsRows, setSavingsRows] = useState([
        { id: uuidv4(), description: '', type: '', quantity: '', unit: '', period: '', origin: 'F2_saving' },
    ]);
    const [dialogTargetId, setDialogTargetId] = useState(null);

    const [positions, setPositions] = useState([]);
    const [period, setPeriod] = useState([]);
    const [unit, setUnit] = useState([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [newConcept, setNewConcept] = useState('');
    const [sendingApiRequest, setSendingApiRequest] = useState(false);
    const [typeImport, setTypeImport] = useState([]);
    const [allDescriptions, setAllDescriptions] = useState([]);
    const [dataToDelete, setDataToDelete] = useState(null);
    const [openSaveDialog, setOpenSaveDialog] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogError, setOpenDialogError] = useState(false);

    const [openMissingFieldsDialog, setOpenMissingFieldsDialog] = useState(false);
    const [missingFields, setMissingFields] = useState([]);

    async function fetchData () {
        setSendingApiRequest(true);
        if (externalCostProposalProject) {
            const descriptionsFromProject = externalCostProposalProject
                .map((row) => row.description) // Extraer las descripciones
                .filter((desc) => desc); // Filtrar descripciones vacías

            const uniqueDescriptions = [...new Set(descriptionsFromProject)]; // Eliminar duplicados
            setAllDescriptions(uniqueDescriptions);
        }
        
        const mappedRows = (savingsStaffProposalProject || [])
            .filter(row => row.origin === 'F2')
            .map((row) => ({
                ...row,
                id: row.id || uuidv4(), // Si no tiene un ID único, generar uno
                // Normalizamos a string para el UI del SearchableSelect
                jobPosition: row?.jobPosition !== undefined && row?.jobPosition !== null ? String(row.jobPosition) : ''
            }));

        setBenefitsRows(mappedRows);

        const mappedSavingsRows = (externalCostProposalProject || []).filter(row => row.origin === 'F2_saving').map((row) => ({
            ...row,
            id: row.id || uuidv4(), // Si no tiene un ID único, generar uno
        }));

        setSavingsRows(mappedSavingsRows);

        await getJobPositionsInUseList().then((response) => {
            if (response !== null) {
                setPositions(response.records);
            }
        });

        await fetch('/api/v1/enumsList') 
            .then((response) => response.json())
            .then((data) => {
                setPeriod(data.periodLevel);
                setUnit(data.unitLevel);
                setTypeImport(data.typeLevel);
            })
        .catch(() => {
            //console.error('Error al obtener los niveles de enums:', error);
        });

        if (savingsStaffProposalProject) {
            setSendingApiRequest(false);
        }
    }

    useEffect(() => {
        fetchData();
    }
    , [savingsStaffProposalProject, externalCostProposalProject]);

    
    // Agregar fila
    const addBenefitRow = () => {
        setBenefitsRows((prevRows) => [
            ...prevRows,
            { id: uuidv4(), jobPosition: '', user: '', period: '', quantity: '' }
        ]);
    };

    const addSavingsRow = () => {
        setSavingsRows((prevRows) => [
            ...prevRows,
            { id: uuidv4(), description: '', type: '', quantity: '', unit: '', period: '', origin: 'F2_saving' },
        ]);
    };
    
    const handleSavingsRowChange = (id, field, value) => {
        setSavingsRows((prevRows) =>
            prevRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
        );
    };
    


    const handleDescriptionChange = (id, value) => {
        if (value === 'custom') {
            setDialogTargetId(id);
            setIsDialogOpen(true);
        } else {
            handleSavingsRowChange(id, 'description', value);
        }
    };

    const removeSavingsRow = async (row) => {
        try {
            
            if (!isNaN(row.id)) {
                await deleteProposalProjectExternalCost(row.id);
            }
    
            // Actualizar el estado eliminando el elemento eliminado
            const id = row.id;
            setSavingsRows((prevRows) => prevRows.filter((row) => row.id !== id));
        } catch (error) {
            alert('No se pudo eliminar el registro. Por favor, intente nuevamente.');
        }
    };

    const handleDeleteBenefitRow = async (row) => {
        try {
            
            if (!isNaN(row.id)) {
                await deleteProposalProjectSavingsStaff(row.id);
            }
    
            // Actualizar el estado eliminando el elemento eliminado
            const id = row.id;
            setBenefitsRows((prevRows) => prevRows.filter((row) => row.id !== id));
        } catch (error) {
            //console.error('Error al eliminar el registro:', error);
            alert('No se pudo eliminar el registro. Por favor, intente nuevamente.');
        }
    };

    

    // Manejar cambios
    const handleBenefitChange = (id, field, value) => {
        setBenefitsRows((prevRows) =>
            prevRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
        );
    };

    
    const handleSubmit = async (event, workflowAction) => {
        event.preventDefault();

        let patchBenefits = true;
        let patchSavings = true;
        let benefitsResponse = true;
        let savingsResponse = true;
        

        const hasEmptyFields = benefitsRows.some(
            (row) => !row.jobPosition || !row.numberOfPeople || !row.period || !row.quantity
        );

        const hasEmptySavings = savingsRows.some(
            (row) =>
                !row.description ||
                !row.type ||
                !row.quantity ||
                (row.type !== 'UNIQUE' && !row.period)
        );
        

        if (hasEmptyFields || hasEmptySavings) {
            setOpenDialogError(true);
            return;
        }

        try {
            // Detectar filas nuevas y modificadas
            benefitsRows.forEach((row) => {
                row.proposalProject = parseInt(idProposalProject);
                row.origin = 'F2';
            });

            const newBenefits = benefitsRows.filter((row) => isNaN(row.id)); // Nuevos beneficios
            const modifiedBenefits = benefitsRows.filter((row) => {
                const initialRow = savingsStaffProposalProject.find((initial) => initial.id === row.id);
                return (
                    initialRow &&
                    (
                        String(initialRow.jobPosition) !== String(row.jobPosition) ||
                        initialRow.numberOfPeople !== row.numberOfPeople ||
                        initialRow.period !== row.period ||
                        initialRow.quantity !== row.quantity
                    )
                );
            });

            // PATCH para filas modificadas
                if (modifiedBenefits.length > 0) {
                    const items = modifiedBenefits.map((r) => ({
                          ...r,
                          // Cast a número para API
                          jobPosition: r.jobPosition ? parseInt(r.jobPosition, 10) : null
                    }));
                    patchBenefits = await patchProposalProjectSavingsStaff({ items });
                }

            // CREATE para filas nuevas
            if (newBenefits.length > 0) {
                const items = newBenefits.map(({ jobPosition, numberOfPeople, ...rest }) => ({
                    ...rest,
                    jobPosition: jobPosition ? parseInt(jobPosition, 10) : null,
                    numberOfPeople: numberOfPeople === '' ? null : (Number.isInteger(numberOfPeople) ? numberOfPeople : parseInt(numberOfPeople, 10)),
                }));
                benefitsResponse = await createProposalProjectSavingsStaff({ items });
                if (benefitsResponse && Array.isArray(benefitsResponse)) {
                    // Emparejar por varios campos para soportar múltiples filas con mismo jobPosition
                    const usedIndexes = new Set();
                    setBenefitsRows((prevRows) =>
                        prevRows.map((row) => {
                            if (!isNaN(row.id)) return row; // ya persistida
                            const matchIndex = benefitsResponse.findIndex((item, idx) => {
                                if (usedIndexes.has(idx)) return false;
                                return (
                                    item?.jobPosition?.id === Number(row.jobPosition) &&
                                    item.numberOfPeople === (row.numberOfPeople === '' ? null : Number(row.numberOfPeople)) &&
                                    item.period === row.period &&
                                    Number(item.quantity) === Number(row.quantity)
                                );
                            });
                            if (matchIndex !== -1) {
                                usedIndexes.add(matchIndex);
                                return { ...row, id: benefitsResponse[matchIndex].id };
                            }
                            return row; // si no encontramos, se quedará como nueva y se intentará de nuevo en el siguiente guardado
                        })
                    );
                }
            }

        } catch (error) {
            alert('Hubo un error al guardar los datos. Por favor, intente nuevamente.');
        }

        try {
            // setSendingApiRequest(true);
            savingsRows.forEach((row) => {
                row.proposalProject = parseInt(idProposalProject);
            });

            const newSavings = savingsRows.filter((row) => isNaN(row.id));
            const modifiedSavings = savingsRows.filter((row) => {
                const initialRow = externalCostProposalProject.find((initial) => initial.id === row.id);
                return (
                    initialRow &&
                    (initialRow.description !== row.description ||
                        initialRow.type !== row.type ||
                        initialRow.quantity !== row.quantity ||
                        initialRow.unit !== row.unit ||
                        initialRow.period !== row.period)
                );
            });

            if (modifiedSavings.length > 0) {
                patchSavings = await patchProposalProjectExternalCost({ items: modifiedSavings });
            }

            if (newSavings.length > 0) {
                savingsResponse = await createProposalProjectExternalCost({ items: newSavings });
                if (savingsResponse && Array.isArray(savingsResponse)) {
                    // setOpenSaveDialog(true);
                    setSavingsRows((prevRows) =>
                        prevRows.map((row) => {
                            const updatedRow = savingsResponse.find(
                                (item) => item.description === row.description
                            );
                            return updatedRow ? { ...row, id: updatedRow.id } : row;
                        })
                    );
                }
            }

        } catch (error) {
            alert('Error saving savings:', error);
        }
        
        if(patchSavings && patchBenefits && benefitsResponse && savingsResponse){
            if (workflowAction === null) {
                setOpenSaveDialog(true);
                reloadData();
            }
        }
        var workflowResponse = null;
        if (workflowAction !== null) {

            if (workflowAction === ProposalProjectConstants.WORKFLOW_USER_TO_ADMIN) {
                const response = await fetch(`/api/v1/proposal-project/${idProposalProject}/comprobate-initial-requeriments-word`);
                const data = await response.json();
                if (Array.isArray(data.mensaje)) {
                    setMissingFields(data.mensaje);
                    setOpenMissingFieldsDialog(true);
                    return; // No continuar si faltan campos
                }
            }

            workflowResponse = await patchProposalProject(parseInt(idProposalProject), {
                workflowAction: workflowAction
            });
        } else {
            workflowResponse = true;
        }

        if (workflowResponse && workflowAction !== null) {
            if (workflowAction === null) setOpenSaveDialog(true);
            reloadData();
        }
    };

    const handleCloseSaveDialog = () => setOpenSaveDialog(false);

    // Abre el dialog para confirmar eliminación
    const confirmDelete = (data, type) => {
        const dataWithType = { ...data, type: type };
        setDataToDelete(dataWithType);        
        setOpenDialog(true);
    };

    const handleConfirmDelete = async () => {
        if (dataToDelete && dataToDelete.type === 'benefits') {
            setSendingApiRequest(true);
            const result = handleDeleteBenefitRow(dataToDelete);
            if (result) {
                setSendingApiRequest(false);
                setOpenDialog(false);
                setDataToDelete(null);
            }
        }

        if (dataToDelete && dataToDelete.type === 'savings') {
            setSendingApiRequest(true);
            const result = removeSavingsRow(dataToDelete);
            if (result) {
                setSendingApiRequest(false);
                setOpenDialog(false);
                setDataToDelete(null);
            }
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setOpenDialogError(false);
        setDataToDelete(null);
    };

    const handleAddConcept = () => {
        if (newConcept.trim()) {
            const newConceptValue = newConcept.trim();
            setAllDescriptions((prev) => [...prev, newConceptValue]);
            handleSavingsRowChange(dialogTargetId, 'description', newConceptValue);
            setNewConcept('');
            setIsDialogOpen(false);
            setDialogTargetId(null);
        }
    };

    const handleDialogClose = () => {
        setNewConcept('');
        setIsDialogOpen(false);
        setDialogTargetId(null);
    };
    // Function to conditionally render action buttons
    const renderActionButtons = () => {
        // If in read-only mode, show a message instead of buttons
        if (readOnly) {
            return (
                <>
                    <Typography variant="h6" mt={4} color="textSecondary">
                        Vista en modo de solo lectura.
                    </Typography>
                    <Typography variant="h6" mt={4} color="textSecondary">
                        {currentStatus !== undefined && currentStatus && 
                        `La propuesta no está en este estado.`}
                    </Typography>
                </>
            );
        }

        // Normal buttons when not in read-only mode
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <Button 
                    variant="contained" 
                    type="submit" 
                    style={{ marginTop: '35px', marginRight: '10px' }}
                    onClick={(e) => {handleSubmit(e, ProposalProjectConstants.WORKFLOW_STEP2_TO_STEP1)}}
                >Volver</Button>
                <Button 
                    variant="contained" 
                    type="submit" 
                    style={{ marginTop: '35px', marginRight: '10px' }}
                    onClick={(e) => {handleSubmit(e, null)}}
                >Guardar</Button>
                <Button 
                    variant="contained" 
                    type="submit" 
                    style={{ marginTop: '35px' }}
                    onClick={(e) => {handleSubmit(e, ProposalProjectConstants.WORKFLOW_USER_TO_ADMIN)}}
                >
                    {checkPermission(ADMIN_PROPOSAL_PROJECT) ? 'Siguiente Paso' : 'Finalizar'}
                </Button>
            </div>
        );
    };

    return (
        <div style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', textAlign: 'center', marginTop: '10px', border: '1px solid #ccc' }}>
            <Box sx={{ p: 4 }}>
                {/* Beneficios */}
                <Box sx={{ mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography variant="h6" mb={1}>¿Qué conseguirás?</Typography>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    El objetivo de este bloque es registrar los beneficios humanos que se obtendrán con el proyecto.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Ejemplo: 2 técnicos de mantenimiento de equipos se ahorrarán 1 semana de trabajo al año.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Puestos:</b> Puestos que se beneficiarán con el proyecto</li>
                                    <li><b>Personas:</b> Número de personas beneficiadas por puesto</li>
                                    <li><b>Periodo Tiempo:</b> Unidad de tiempo</li>
                                    <li><b>Cantidad Tiempo:</b> Valor numérico del tiempo ahorrado</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary" sx={{  }}>¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
                <Paper sx={{ p: 2, backgroundColor: '#e0f7fa', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                    <Grid container spacing={2} mb={2}>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Puestos</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Personas</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Periodo Tiempo (AL AÑO)</Typography>
                        </Grid>
                        <Grid item xs={readOnly ? 3 : 2}>
                            <Typography variant="subtitle2" sx={headerStyle}>Cantidad Tiempo</Typography>
                        </Grid>
                        {!readOnly && (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={addBenefitRow}>
                                    <AddCircleOutlineIcon color="primary" />
                                </IconButton>
                            </Grid>
                        )}
                    </Grid>

                    {benefitsRows.map((row) => (
                        <Grid container spacing={2} key={row.id} mb={1}>
                            <Grid item xs={3}>
                            <SearchableSelect
                                options={positions}
                                value={row.jobPosition}
                                onChange={(e) => handleBenefitChange(row.id, 'jobPosition', e.target.value)}
                                disabled={readOnly}
                                placeholder="Seleccione una opción"
                                renderOption={(option) => option.name}
                            />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={row.numberOfPeople}
                                    onChange={(e) => {
                                        // Asegurarse de que solo se acepten números enteros positivos
                                        const value = e.target.value;
                                        const parsedValue = parseInt(value, 10);
                                        // Si es vacío usar vacío, si es un número usar el máximo entre el número y 0, si no es un número usar 0
                                        const intValue = value === '' ? '' : (isNaN(parsedValue) ? 1 : Math.max(1, parsedValue));
                                        handleBenefitChange(row.id, 'numberOfPeople', intValue);
                                    }}
                                    placeholder="Número de personas"
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: "[0-9]*",
                                        min: "1"
                                    }}
                                    disabled={readOnly}
                                    type="number"
                                    helperText="Mínimo 1 persona"
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={row.period}
                                    onChange={(e) => handleBenefitChange(row.id, 'period', e.target.value)}
                                    disabled={readOnly}
                                >
                                    <MenuItem value=""><em>Seleccione una opción</em></MenuItem>
                                    {period.map((p) => (
                                        <MenuItem key={p.key} value={p.key}>{p.value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item xs={readOnly ? 3 : 2}>
                            <TextField
                                fullWidth
                                size="small"
                                value={row.quantity}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Convierte el valor a float si es válido, de lo contrario usa 0 o null
                                    const floatValue = value === '' ? null : parseFloat(value) || 0;
                                    handleBenefitChange(row.id, 'quantity', floatValue);
                                }}
                                placeholder="Escribe un número"
                                inputProps={{
                                    inputMode: 'decimal', // Sugerencia de teclado numérico
                                    pattern: "^\\d*\\.?\\d*$", // Validación en el lado del cliente
                                }}
                                disabled={readOnly}
                            />

                            </Grid>
                            {!readOnly && (
                                <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                    <IconButton size="small" onClick={() => confirmDelete(row,'benefits')}>
                                        <DeleteIcon color="error" />
                                    </IconButton>
                                </Grid>
                            )}
                        </Grid>
                    ))}
                </Paper>

                {/* ¿Qué te ahorras? */}
                <Box sx={{ mt:2, mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography variant="h6" mr={1}>¿Qué te ahorras?</Typography>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    El objetivo de este bloque es registrar los ahorros en tiempo y/o dinero que generará el proyecto.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Ejemplo: Ahorro de 500€ mensuales en gastos de mantenimiento.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Concepto:</b> Descripción del ahorro</li>
                                    <li><b>Tipo Importe:</b> Único (una sola vez) o Periódico (Se deberá rellenar Periodo Tiempo)</li>
                                    <li><b>Cantidad Importe:</b> Valor numérico del ahorro</li>
                                    <li><b>Unidad:</b> Tiempo o dinero</li>
                                    <li><b>Periodo Tiempo:</b> Frecuencia del ahorro (para ahorros periódicos)</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary" sx={{  }}>¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
                <Paper sx={{ p: 2, backgroundColor: '#e0f7fa', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                    <Grid container spacing={2} mb={2}>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Concepto</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="subtitle2" sx={headerStyle}>Tipo Importe</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="subtitle2" sx={headerStyle}>Cantidad Importe</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="subtitle2" sx={headerStyle}>Unidad</Typography>
                        </Grid>
                        <Grid item xs={readOnly ? 3 : 2}>
                            <Typography variant="subtitle2" sx={headerStyle}>Periodo Tiempo</Typography>
                        </Grid>
                        {!readOnly && (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={addSavingsRow}>
                                    <AddCircleOutlineIcon color="primary" />
                                </IconButton>
                            </Grid>
                        )}
                    </Grid>

                    {savingsRows.map((row) => (
                        <Grid container spacing={2} key={row.id} mb={1}>
                            <Grid item xs={3}>
                            <SearchableSelect
                                options={[...allDescriptions.map((desc) => ({ value: desc })), { value: 'custom' }]}
                                value={row.description}
                                onChange={(e) => handleDescriptionChange(row.id, e.target.value)}
                                disabled={readOnly}
                                placeholder="Seleccione una opción"
                                renderOption={(option) =>
                                    option.value === 'custom' ? <em>Escribir concepto</em> : option.value
                                }
                            />
                            </Grid>
                            <Grid item xs={2}>
                                <RadioGroup
                                    row
                                    value={row.type}
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        handleSavingsRowChange(row.id, 'type', newValue);
                            
                                        // Si el tipo es UNIQUE, limpia el campo 'period'
                                        if (newValue === 'UNIQUE') {
                                            handleSavingsRowChange(row.id, 'period', '');
                                        }
                                    }}
                                >
                                    {typeImport.map((p) => (
                                        <FormControlLabel key={p.key} value={p.key} control={<Radio />} label={p.value} 
                                            disabled={readOnly}
                                        />
                                    ))}
                                </RadioGroup>
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={row.quantity}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Convierte el valor a float si es válido, de lo contrario usa 0 o null
                                        const floatValue = value === '' ? null : parseFloat(value) || 0;
                                        handleSavingsRowChange(row.id, 'quantity', floatValue);
                                    }}
                                    placeholder="Escribe un número"
                                    inputProps={{
                                        inputMode: 'decimal', // Sugerencia de teclado numérico para dispositivos móviles
                                        pattern: "^\\d*\\.?\\d*$", // Correcta forma en cadenas JavaScript
                                    }}
                                    disabled={readOnly}
                                />

                            </Grid>
                            <Grid item xs={2}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={row.unit}
                                    onChange={(e) => handleSavingsRowChange(row.id, 'unit', e.target.value, setSavingsRows)}
                                    disabled={readOnly}
                                >
                                    <MenuItem value=""><em>Seleccione una opción</em></MenuItem>
                                    {unit.map((p) => (
                                        <MenuItem key={p.key} value={p.key}>{p.value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item xs={readOnly ? 3 : 2}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={row.period}
                                    onChange={(e) => handleSavingsRowChange(row.id, 'period', e.target.value, setSavingsRows)}
                                    disabled={readOnly || row.type === 'UNIQUE'}
                                >
                                    <MenuItem value=""><em>Seleccione una opción</em></MenuItem>
                                    {period.map((p) => (
                                        <MenuItem key={p.key} value={p.key}>{p.value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            {!readOnly && (
                                <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                    <IconButton size="small" onClick={() => confirmDelete(row,'savings')}>
                                        <DeleteIcon color="error" />
                                    </IconButton>
                                </Grid>
                            )}
                        </Grid>
                    ))}
                </Paper>


                {/* Dialog para agregar un concepto */}
                <Dialog open={isDialogOpen} onClose={handleDialogClose}>
                    <DialogTitle>Escribir nuevo concepto</DialogTitle>
                    <DialogContent>
                        <TextField
                            fullWidth
                            value={newConcept}
                            onChange={(e) => setNewConcept(e.target.value)}
                            placeholder="Ingrese el nuevo concepto"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose}>Cancelar</Button>
                        <Button onClick={handleAddConcept} color="primary">
                            Agregar
                        </Button>
                    </DialogActions>
                </Dialog>

                {renderActionButtons()}

                <Dialog open={openDialog} onClose={handleCloseDialog}>
                    <DialogTitle>Confirmar Eliminación</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Estás seguro de que deseas eliminar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleConfirmDelete} color="error">
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>
                
                {/* Dialog de Confirmación de Éxito */}
                <Dialog open={openSaveDialog} onClose={handleCloseSaveDialog}>
                    <DialogTitle>Guardado Exitoso</DialogTitle>
                    <DialogContent>
                        <DialogContentText>El proyecto ha sido guardado exitosamente.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseSaveDialog} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={openDialogError} onClose={handleCloseDialog}>
                    <DialogTitle>Error</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Se debe rellenar todos los datos.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openMissingFieldsDialog} onClose={() => setOpenMissingFieldsDialog(false)}>
                    <DialogTitle>Campos requeridos incompletos</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Estos son los campos que faltan por rellenar en el archivo de requerimientos iniciales. Por favor, vaya al paso anterior y vuelva a subir el archivo completo:
                        </DialogContentText>
                        <ul>
                            {missingFields.map((field, idx) => (
                                <li key={idx}>{t(`proposalProject.excel.${field}`)}</li>
                            ))}
                        </ul>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenMissingFieldsDialog(false)} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                <DialogLoader open={sendingApiRequest} />

            </Box>
        </div>
    );
};

SecondStep.propTypes = {
    idProposalProject: propTypes.number,
    savingsStaffProposalProject: propTypes.array,
    externalCostProposalProject: propTypes.array,
    reloadData: propTypes.func,
    readOnly: propTypes.bool,
    currentStatus: propTypes.string
};

export default SecondStep;
